module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-mobile-372772775f897ca162011505737043d7.jpg";